import styled from 'styled-components';

const JobsContentWrapper = styled.section`
  .screen-caption {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1em;
  }
  .screen-name {
    font-weight: normal;
    font-size: 2.2rem;
    margin: 0;
  }
  .filter-section {    
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    .practitioner-select-wrapper {
      width: 305px;
    }

    .date-range {
      margin: 0 2em;
      width: 27%;
      min-width: 270px;
      display: flex;
      align-items: flex-end;
      .delimiter {
        display: block;
        color: ${p => p.theme.color.label};
        padding: .8em .5em;
      }
    }
  }
  .action-btn {
    background-color: ${p => p.theme.color.primary};
    border-radius: 6px;
    font-size: 1.15rem;
    text-align: center;
    padding: .7em;
    min-width: 240px;
    color: ${p => p.theme.color.white}; 
  }

  .jobs-table {   
    tbody {
      tr {
        cursor: pointer;
        &.active {
          background-color: ${p => p.theme.color.veryLightBlue};
        }
        &.error {
          color: ${p => p.theme.color.error};
        }
      }
    }           
     /* setup size */
     td, th {
      &:nth-of-type(1) {
        width: 21.739130434782609%;
      }
      &:nth-of-type(2) {
        width: 20.289855072463768%;
      }
      &:nth-of-type(3) {
        width: 10.869565217391304%;
      }
      &:nth-of-type(4) {
        width: 21.739130434782609%;
      }
      &:nth-of-type(5) {
        width: 7.246376811594203%;
      }
      &:nth-of-type(8) {
        width: 18.115942028985507%;
      }
     }   
  }
`;


export default {
  JobsContentWrapper
};